export interface Days {
  mo: boolean
  tu: boolean
  we: boolean
  th: boolean
  fr: boolean
  sa: boolean
  su: boolean
}

export type Day = keyof Days
export const ALL_DAYS: ReadonlyArray<Day> = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']
export type WeekdayIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6

export const dayToIndex: Record<Day, number> = {
  mo: 0,
  tu: 1,
  we: 2,
  th: 3,
  fr: 4,
  sa: 5,
  su: 6,
}

/* Days to map the values of charging strategy, because it starts with sunday, but needs to be displayed started by monday */
export const CHARGING_DAYS: ReadonlyArray<Day> = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa']
